export default __webpack_public_path__ + "e296f8e5e684a91592b9a8036e77e1c1.png";